<div class="main-container">
  <div class="steps">
    <div class="steps__text-content">
      <h2 class="step-title" #titleEl tabindex="-1">
        {{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.STEP_1" | translate
        }}
      </h2>
      <p class="step-description">
        {{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.STEP_1_DESCRIPTION"
            | translate
        }}
        <a target="_blank" href="{{ googleAuthenticatorLink }}">{{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.GOOGLE" | translate
        }}</a
        >,
        <a target="_blank" href="{{ microsoftAuthenticatorLink }}">{{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.MICROSOFT"
            | translate
        }}</a
        >,
        {{ "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.OR" | translate }}
        <a target="_blank" href="{{ authyLink }}">{{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.AUTHY" | translate
        }}</a
        >.
      </p>
    </div>
    @if (isLoadingQrCode) {
      <div class="steps__qr-content">
        <app-loading style="padding: 16px"></app-loading>
      </div>
    }
    @if (!isLoadingQrCode) {
      <div class="steps__qr-content">
        <img src="{{ qrCodeString }}" alt="" class="qr-code" />
        <div class="qr-text-content">
          <p class="qr-hint">
            {{
              "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.QR_HINT"
                | translate
            }}
          </p>
          <button (click)="copySecret()" class="qr-copy-banner">
            <p class="qr-copy-banner__code">{{ qrSecret }}</p>
            <div class="qr-copy-banner__button">
              <mat-icon class="button-icon">content_copy</mat-icon
              >{{
                "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.COPY"
                  | translate
              }}
            </div>
          </button>
        </div>
      </div>
    }
  </div>
  <div class="steps">
    <form class="steps__text-content">
      <h2 class="step-title">
        {{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.STEP_2" | translate
        }}
      </h2>
      <p class="step-description">
        {{
          "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.STEP_2_DESCRIPTION"
            | translate
        }}
      </p>
      <cari-input-container>
        <input
          class=""
          cari-input
          autocomplete="one-time-code"
          id="verification-code"
          name="verificationCode"
          [formControl]="verificationCode"
          [placeholder]="
            'REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.INPUT_PLACEHOLDER'
              | translate
          "
          type="text"
          inputmode="text"
          aria-required="true"
          aria-describedby="verification-code-error"
          [aria-invalid]="
            (verificationCode.errors?.required ||
              verificationCode.errors?.invalid) &&
            verificationCode.touched
          "
        />
        <cari-input-error id="verification-code-error">
          @if (verificationCode.errors?.required && verificationCode.touched) {
            <span>{{
              "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.ERRORS.REQUIRED"
                | translate
            }}</span>
          }
          @if (verificationCode.errors?.invalid && verificationCode.touched) {
            <span>{{
              "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.ERRORS.INVALID"
                | translate
            }}</span>
          }
        </cari-input-error>
      </cari-input-container>
    </form>
  </div>
  <button
    class="action-button"
    cari-button
    data-shape="round"
    data-type="neutral"
    data-style="fill"
    data-size="large"
    #submitButton
    (click)="turnOnVerification()"
  >
    {{ "REGISTER.TWO_STEP_VERIFICATION.TOTP_VERIFICATION.BUTTON" | translate }}
  </button>
</div>
